import React from 'react';
import { parseISO, isValid } from 'date-fns';
import { format } from 'date-fns-tz';
import { DateFormats } from 'enuns/DateTypes';

export const TIME_ZONE_SP: string = 'America/Sao_Paulo';

export const getFormatedDateTime = (
  date: string | number | Date,
  newFormat: DateFormats | DateFormats.DateTime
): string => {
  return format(date, newFormat, {
    timeZone: TIME_ZONE_SP,
  });
};

export const getDate = (date: string | number | Date): string => {
  return getFormatedDateTime(date, DateFormats.Date);
};

export const getTime = (date: string | number | Date): string => {
  return getFormatedDateTime(date, DateFormats.Time);
};

export const getFullTime = (date: string | number | Date): string => {
  return getFormatedDateTime(date, DateFormats.FullTime);
};

export const getDateTime = (date: string | number | Date): string => {
  return getFormatedDateTime(date, DateFormats.DateTime);
};

export const getDateFullTime = (date: string | number | Date): string => {
  return getFormatedDateTime(date, DateFormats.DateFullTime);
};

type CallbackFunction = (value: string) => void;

export const inputDateMask = (callback: CallbackFunction) => {
  return (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value.trim().replace(/[^0-9]/g, '').substr(0, 10);
    let masked = '';
    if (value.length > 4) {
      masked = value.slice(0, 2) + '/' + value.slice(2, 4) + '/' + value.slice(4, 8);
    } else if (value.length > 2) {
      masked = value.slice(0, 2) + '/' + value.slice(2, 4);
    } else {
      masked = value;
    }
    callback(masked);
  };
};

export const inputTimeMask = (callback: CallbackFunction) => {
  return (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value.trim().replace(/[^0-9]/g, '').substr(0, 4);
    let masked = '';
    if (value.length > 2) {
      masked = value.slice(0, 2) + ':' + value.slice(2);
    } else {
      masked = value;
    }
    callback(masked);
  };
};

export const inputDateTimeMask = (value: string) => {
  const clean = value.trim().replace(/[^0-9]/g, '');
  if (clean.match(/^\d{3,4}$/)) {
    return clean.slice(0,2) + '/' + clean.slice(2);
  }
  if (clean.match(/^\d{5,8}$/)) {
    return clean.slice(0,2) + '/' + clean.slice(2,4) + '/' + clean.slice(4);
  }
  if (clean.match(/^\d{9,10}$/)) {
    return clean.slice(0,2) + '/' + clean.slice(2,4) + '/' + clean.slice(4,8) + ' ' + clean.slice(8);
  }
  if (clean.match(/^\d{11,12}$/)) {
    return clean.slice(0,2) + '/' + clean.slice(2,4) + '/' + clean.slice(4,8) + ' ' + clean.slice(8, 10) + ':' + clean.slice(10);
  }
  if (clean.match(/^\d{13}$/)) {
    return clean.slice(0,2) + '/' + clean.slice(2,4) + '/' + clean.slice(4,8) + ' ' + clean.slice(8, 10) + ':' + clean.slice(10, 12) + ':' + clean.slice(12);
  }
};

export const isAValidDate = (ISODate: string) => {
  const parsed = parseISO(ISODate);
  return parsed instanceof Date && !isNaN(parsed.valueOf());
};

export const localeDateToISO = (localeDate: string) => {
  return localeDate.split('/').reverse().join('-');
};

export const isAValidTime = (time: string) => {
  return time.split(':').join('').length === 4 && isValid(new Date('2020-01-01 ' + time));
}